import DoneIcon from 'assets/images/buySubscription/done.svg'
export default function Fee() {
    return (
        <div className=" bg-white mx-2 my-3 p-3 rounded-2xl">
            <p className=" text-lg">امکانات نسخه‌ی کارمزدی</p>
            <div className=" flex my-2">
                <img src={DoneIcon} alt="done" className=" ml-2" />
                <p>امکان افزودن عضو به تعداد نامحدود</p>
            </div>
            <div className=" flex my-2">
                <img src={DoneIcon} alt="done" className=" ml-2" />
                <p>امکان تعریف وام به تعداد نامحدود</p>
            </div>
            <div className=" flex my-2">
                <img src={DoneIcon} alt="done" className=" ml-2" />
                <p>امکان پرداخت از طریق درگاه</p>
            </div>
            <div className=" flex my-2">
                <img src={DoneIcon} alt="done" className=" ml-2" />
                <p>امکان ثبت دستی تراکنش‌ها</p>
            </div>
            <div className=" flex my-2">
                <img src={DoneIcon} alt="done" className=" ml-2" />
                <p>اطلاع‌رسانی رویدادها از طریق پیامک رایگان</p>
            </div>
            <div className=" flex my-2">
                <img src={DoneIcon} alt="done" className=" ml-2" />
                <p>ذخیره اطلاعات صندوق در فضای ابری</p>
            </div>
        </div>
    )
}
